/**
 * Reemplaza un elemento en un array por un nuevo valor en la posición indicada.
 * @param {Array} arr - El array original
 * @param {number} index - La posición a reemplazar
 * @param {*} newValue - El nuevo valor que se insertará en esa posición
 * @returns {Array} - Un nuevo array con el valor reemplazado
 */
export function replaceAt(arr, newValue, index) {
    if (!Array.isArray(arr)) {
        throw new Error("El primer parámetro debe ser un array");
    }
    if (index < 0 || index >= arr.length) {
        throw new Error("Índice fuera de rango");
    }

    return arr.map((item, i) => (i === index ? newValue : item));
}

/**
 * Une dos arrays en uno solo.
 * @param {Array} arr1 - Primer array
 * @param {Array} arr2 - Segundo array
 * @returns {Array} - Nuevo array combinado
 */
export const mergeArrays = (arr1, arr2) => {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
        throw new Error("Ambos parámetros deben ser arrays");
    }
    const clone1 = structuredClone(arr1);
    const clone2 = structuredClone(arr2);
    const merged = [ ...clone1, ...clone2 ];
    const unique = merged.filter(
        (item, index, self) =>
            index === self.findIndex((obj) => obj.id === item.id)
    );
    return unique;
};
